// extracted by mini-css-extract-plugin
export default {"sidebarMenu":"Sidebar_sidebarMenu__SEXf+","active":"Sidebar_active__xrnCZ"};